import React from 'react';

import { i18n } from '@lt/localization';
import type { CommonFilterProps, ExtendedFilterInfo } from '../types';

import MultichoiceFilterGroup from '../../../../../../../components/Filters/components/MultichoiceFilterGroup';

const FilterTransitionsTime = (props: CommonFilterProps) => (
  <MultichoiceFilterGroup {...props} Filter={FilterTransitionsTime} />
);

const filterNames = {
  less_than_3_hours: i18n.t('checkout.filter.transitions.lessThreehours'),
  less_than_6_hours: i18n.t('checkout.filter.transitions.lessSixhours'),
  less_than_12_hours: i18n.t('checkout.filter.transitions.lessTwelvehours'),
  more_than_12_hours: i18n.t('checkout.filter.transitions.moreTwelvehours'),
};

FilterTransitionsTime.getFilterVisibleName = (
  filterOptionData: ExtendedFilterInfo,
) => filterOptionData.id && filterNames[filterOptionData.id];

FilterTransitionsTime.filterName = 'transitions_time';
FilterTransitionsTime.filterLabel = i18n.t(
  'checkout.filter.transitions.timeLabel',
);

export default FilterTransitionsTime;
